import React, { useState, useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { IPageListItem } from '../../../types/landing-api-response.model';

export default function SearchListItem({
  pageItem,
  handleSearchItemNavigation,
  isSearchItemLoading,
  isHovered
}: {
  pageItem: IPageListItem;
  handleSearchItemNavigation: (fav) => void;
  isSearchItemLoading: boolean;
  isHovered: boolean;
}) {
  // local state for loading while navigating to scenario
  const [isScenarioLoading, setIsScenarioLoading] =
    useState(isSearchItemLoading);

  // handle for navigating to respective page/scenario
  const handleNavigation = () => {
    // setting is scenario loading true
    setIsScenarioLoading(true);

    // handler for navigating
    handleSearchItemNavigation(pageItem);
  };

  return (
    <div className='fav-item-div' onClick={handleNavigation}
      onKeyDown={(e: { key: string; }) => {
        if (e.key == 'Enter' || e.key == '') {
          handleNavigation();
        }
      }}
    >
      <div className='fav-title-div'>
        <div className='fav-main-title' style={{ fontSize: '14px' }}>
          {pageItem.alias}
        </div>
      </div>
      {isScenarioLoading ? (
        <CircularProgress size={20} />
      ) : (
        isHovered && (
          <KeyboardArrowRightIcon sx={{ color: '#1E1E1E', fontSize: '16px' }} />
        )
      )}
    </div>
  );
}
